import { Select } from "antd";
import { Formik, Form } from "formik";
import React from "react";
import { useSelector, useDispatch } from "react-redux";

import ButtonLoader from "@/Components/ButtonLoader";
import FieldErrorMessage from "@/Components/common/FieldErrorMessage";
import ModalPopUp from "@/Components/common/ModalPopUp";
import { RequiredSymbol } from "@/Components/common/RequiredSymbol";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import {
  fetchClientContactAlldata,
  fetchClientUsers,
  setClientUsersLoading,
  togglePrimaryModal,
  updatePagination,
} from "@/reducers/client_user/clientUsers";
import { updateUser } from "@/reducers/clientprofile";
import { _updateClientContactPrimary } from "@/services/clientusers";
import { handleAPICatch, showSuccessToast } from "@/utilities/utils";

const SelectPrimaryContactModal = () => {
  const {
    showPrimaryModal,
    clientUsers,
    clientContactAll,
    isClientContactAllLoading,
  } = useSelector((state) => state.clientUsers);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(togglePrimaryModal(false));
  };

  return (
    <ModalPopUp
      show={showPrimaryModal}
      panelClass="max-w-[734px] max-sm:max-w-[400px]"
      onClose={handleClose}
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <div>
            <h3 className="text-[20px] font-semibold leading-[normal] text-black">
              Transfer ownership
            </h3>
            <p className="mt-1 text-[14px] font-normal leading-[normal] !text-txtColor">
              Select another user to transfer ownership as a primary contact.
            </p>
          </div>
          <div>
            <button
              onClick={handleClose}
              className="text-red outline-none ring-0"
            >
              <RejectIcon />
            </button>
          </div>
        </div>
        <div>
          <Formik
            initialValues={{
              primaryContact: [],
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validateOnMount={false}
            validate={(values) => {
              const errors = {};
              if (values.primaryContact.length === 0) {
                errors.primaryContact = "Please select primary contact";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              let response = _updateClientContactPrimary({
                primary_contact_id: values.primaryContact,
              });
              response
                .then((res) => {
                  const {
                    data: { message },
                  } = res;
                  dispatch(
                    updatePagination({
                      currentPage: 1,
                      isLastPage: false,
                    }),
                  );
                  dispatch(setClientUsersLoading(true));
                  dispatch(fetchClientUsers());
                  dispatch(togglePrimaryModal(false));
                  showSuccessToast(message);
                  dispatch(fetchClientContactAlldata());
                  dispatch(
                    updateUser({
                      is_primary_contact: 0,
                    }),
                  );
                })
                .catch((error) => {
                  handleAPICatch(error);
                })
                .finally(() => {
                  // setSubmitting(false);
                  setDisabledAddBtn(false);
                  setIsSubmitting(false);
                });
            }}
          >
            {({
              submitForm,
              isSubmitting,
              errors,
              touched,
              setFieldValue,
              values,
            }) => (
              <Form>
                <div className="grid gap-3">
                  <label
                    htmlFor="role"
                    className="text-[14px] font-medium leading-[normal] text-txtColor"
                  >
                    Primary contact <RequiredSymbol />
                  </label>
                  <div className="flex flex-col">
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      placeholder="Select user"
                      optionFilterProp="children"
                      className={`ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary ${errors.primaryContact && touched.primaryContact ? "!border-red-500" : ""}`}
                      name="role"
                      suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                      onChange={(value) => {
                        setFieldValue("primaryContact", value);
                      }}
                      value={values.primaryContact}
                    >
                      {isClientContactAllLoading ? (
                        <Select.Option
                          value=""
                          className="!text-black"
                          disabled
                        >
                          <p>Please wait...</p>
                        </Select.Option>
                      ) : (
                        Array.isArray(clientContactAll) &&
                        clientContactAll.map((item, index) => {
                          const { contact_name, contact_id } = item;
                          return (
                            <Select.Option value={contact_id} key={index}>
                              {contact_name}
                            </Select.Option>
                          );
                        })
                      )}
                    </Select>
                    <FieldErrorMessage name="primaryContact" />
                  </div>
                </div>
                {values.primaryContact.length > 0 ? (
                  <div className="mt-4 flex flex-col">
                    <p className="text-[14px] font-semibold leading-[normal] text-black">
                      <span className="text-blue">
                        {" "}
                        {
                          clientContactAll.find(
                            (item) => item.contact_id === values.primaryContact,
                          )?.contact_name
                        }{" "}
                      </span>
                      will have a Primary contact tag into the list.
                    </p>
                  </div>
                ) : null}

                <div className="mt-6 flex justify-end gap-[20px]">
                  <button
                    type="button"
                    className="transition-linear relative h-[45px] w-[120px] rounded-lg border border-primary bg-primary text-[14px] font-medium text-white hover:bg-none hover:text-primary"
                    onClick={submitForm}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <ButtonLoader /> : <span>Apply</span>}
                  </button>
                  <button
                    type="button"
                    className="transition-linear h-[45px] w-[120px] rounded-lg border border-primary bg-none text-[14px] font-medium text-primary hover:bg-primary hover:text-white"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default SelectPrimaryContactModal;
